import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TeacherComment } from '../models/teacher-comment';
import { AppSettings } from '../../../../utils/app-settings';

@Injectable()
export class TeachersCommentsService {

  constructor(private http: HttpClient) { }

  getTeachersComments(): Observable<Array<TeacherComment>> {
    return this.http.get<Array<TeacherComment>>(AppSettings.apiUrl + "teacherscomments");
  }

  markTeachersCommentAsRead(id: number) {
    return this.http.post(AppSettings.apiUrl + "teacherscomments/mark-as-read", {"id":id});
  }
}
